import {
  Component,
  Inject,
  OnInit,
  PLATFORM_ID,
  HostListener,
} from '@angular/core';
import { Subscription } from 'rxjs/internal/Subscription';
import { ApiService } from '../../shared/services/apiService.service';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { Router } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
import { SkeletonService } from 'src/app/shared/services/skeleton.service';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from '../../../environments/environment';

declare var $: any;
@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss'],
})
export class BannerComponent implements OnInit {
  bannerList: any;
  isLoading: any = false;
  environment1 = environment.s3bucket.url;
  applicationData: any = [];
  segmentsData: any = [];
  selectedApplication: any = '';
  productModelData: any = [];
  applicationDataRes: any = [];
  segmentsDataRes: any = [];
  productModelDataRes: any = [];
  isMobile: boolean;
  height: number = 0;
  width: number = 0;
  arr = [];
  hasDealerCode: boolean = false;
  windowWidth: number = window.innerWidth;
  windowHeight: number = window.innerHeight;
  resizedImageUrl: any;
  constructor(
    private ApiService: ApiService,
    public skeletonService: SkeletonService,
    private toastrService: ToastrService,
    private spinner: NgxSpinnerService,

    @Inject(PLATFORM_ID) private platformId: Object,
    private router: Router
  ) {}
  sub: Subscription = new Subscription();

  customOptionsForBanner: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: true,
    navSpeed: 1200,
    autoplay: true,
    // nav: true,
    responsiveRefreshRate: 1000000,

    responsive: {
      0: {
        items: 1,
      },
      400: {
        items: 1,
      },
      740: {
        items: 1,
      },
      940: {
        items: 1,
      },
    },

  }
  processedBannerList: any[] = [];
  ngOnInit(): void {
    //  this.height=window.innerHeight;
    //  this.width=window.innerWidth
    if (isPlatformBrowser(this.platformId)) {
      this.height = window.innerHeight;
      this.width = window.innerWidth
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }
    }
    const dealername = localStorage.getItem('dealername');
    this.hasDealerCode = !!dealername; 
    this.getBanners();
    this.closeModalOnOutsideClick();
  }

  @HostListener('document:mousedown', ['$event'])
  @HostListener('window:resize', ['$event'])
    onResize(event: any) {
      this.windowWidth = event.target.innerWidth;
      this.windowHeight = event.target.innerHeight;

      // this.updateImageSize('',this.windowWidth,this.windowHeight);
      this.processedBannerList.forEach((banner) => {
        banner.updatedUrl = this.updateImageSize(banner.updatedUrl, this.windowWidth, this.windowHeight);
      });

    }
    updateImageSize(imageUrl: string, width?: number, height?: number): string {
      if (!imageUrl) return '';

      // Default width and height
      width = width && !isNaN(width) && width > 0 ? width : window.innerWidth;
      height = height && !isNaN(height) && height > 0 ? height : window.innerHeight;
  
      let imgWidth = Math.floor(width);
      let imgHeight = Math.floor(height);
  
      return `${imageUrl.replace(/\/resize\/\d+x\d+$/, '')}/resize/${imgWidth}x${imgHeight}`;
    }
  onMousedown(event: MouseEvent) {
    const modal = document.getElementById('modalAuto');
    const modalSegment = document.getElementById('modalAutoSegment');
    const modalProduct = document.getElementById('modalAutoProduct');

    if (modal && !modal.contains(event.target as Node)) {
      modal.style.display = 'none';
    }

    if (modalSegment && !modalSegment.contains(event.target as Node)) {
      modalSegment.style.display = 'none';
    }

    if (modalProduct && !modalProduct.contains(event.target as Node)) {
      modalProduct.style.display = 'none';
    }
  }

  closeModalOnOutsideClick() {
    document.addEventListener('mousedown', (event) => {
      const modal = document.getElementById('modalAuto');
      const modalSegment = document.getElementById('modalAutoSegment');
      const modalProduct = document.getElementById('modalAutoProduct');

      if (modal && !modal.contains(event.target as Node)) {
        modal.style.display = 'none';
      }

      if (modalSegment && !modalSegment.contains(event.target as Node)) {
        modalSegment.style.display = 'none';
      }

      if (modalProduct && !modalProduct.contains(event.target as Node)) {
        modalProduct.style.display = 'none';
      }
    });
  }

  GetTest(data: any) {
    if (isPlatformBrowser(this.platformId)) {
      let url;
      var dataUrl = data.banner_link;
      if (dataUrl === 'fleetverse-tmfl') {
        // url = 'https://www.tmf.co.in/fleetverse';
        url='https://www.tmf.co.in/workingcapital?utm_source=workingcapital&utm_medium=banner&utm_campaign=tatamotors';
        window.open(url, '_blank');
      } else {
        url = dataUrl?.replace(window.location.origin + '/' + dataUrl);
        this.router.navigateByUrl(url);
      }
    }
  }

  getBanners() {
    try {
      let req = {
        page: 'HOME',
        offset: 0,
        size: 6,
         source:this.isMobile ? 'webapp':'web'
      };
      this.sub.add(
        this.ApiService.getBannerListNew(req).subscribe({
        next: (response: any) => {
          if (response.success) {
            this.spinner.hide();
            this.isLoading = true;
            this.bannerList = response;
            this.preloadBanners(this.bannerList);
            // this.bannerList.data.forEach(element => {
            //   var abc= element.path.replace("cv_online/BannerFiles/","https://ik.imagekit.io/nq1nxw7tt/");
            // var  ab=abc+"?tr=w-"+this.width
            //    this.arr.push(ab);

            //  });
            } else {
            this.spinner.hide();
            this.bannerList = [];
            this.isLoading = false;
              if (response?.data?.msg == 'User is not registered.') {
                this.toastrService.warning(response.data.msg || response.msg);
              } else {
              this.bannerList = [];
              this.isLoading = false;
              this.spinner.hide();
            }
          }
        },
        error: () => {
          this.isLoading = false;
            this.toastrService.warning('Something went wrong!');
          this.spinner.hide();
        },
          complete: () => {},
        })
      );
    } catch (error) {}
  }
  preloadBanners(apiResponse): void {
    // Process banners and generate URLs
    this.processedBannerList = apiResponse.data.map((banner) => ({
      ...banner,
      updatedUrl: this.updateImageSize(apiResponse.cfrnt_url + banner.path)
    }));
    
  }
  getApplicationData() {
    let data = {
      sub_lob: 'ALL',
    };
    this.sub.add(
      this.ApiService.getAllApplications(data).subscribe({
      next: (res: any) => {
          this.applicationData = res.data;
          this.applicationDataRes = res.data;
      },
        error: () => {},
        complete: () => {},
      })
    );
  }
  getSegmentsData(value: any, flag) {
    if (!flag && this.segmentsDataRes?.length > 0) {
      return;
    }
    let data = {
      vehicle_application: value,
    };
    this.sub.add(
      this.ApiService.getSegment(data).subscribe({
      next: (res: any) => {
        this.segmentsData = [];
          res.data.lob.forEach((res) => {
            this.segmentsData.push({ eleName: res, img_url: '' });
        });

        if (isPlatformBrowser(this.platformId)) {
            if (
              localStorage.getItem('menuItem') &&
              localStorage.getItem('menuItem').includes('data')
            ) {
            let response = JSON.parse(localStorage.getItem('menuItem'));
              var result = Object.keys(response.data).map((key) => [
                key,
                response.data[key],
              ]);
              result.forEach((element) => {
              for (const key in element[1]) {
                  let i = this.segmentsData.findIndex((x) => x.eleName == key);
                if (i >= 0) {
                    this.segmentsData[i].img_url =
                      element[1][key]['ppl_list'][0].image;
                }
              }
            });
            } else {
              this.sub.add(
                this.ApiService.getMenuItemList().subscribe({
              next: (response: any) => {
                localStorage.setItem('menuItem', JSON.stringify(response));
                    var result = Object.keys(response.data).map((key) => [
                      key,
                      response.data[key],
                    ]);
                    result.forEach((element) => {
                  for (const key in element[1]) {
                        let i = this.segmentsData.findIndex(
                          (x) => x.eleName == key
                        );
                    if (i >= 0) {
                          this.segmentsData[i].img_url =
                            element[1][key]['ppl_list'][0].image;
                    }
                  }
                });
              },
                  error: () => {},
                  complete: () => {},
            })
              );
          }
          this.segmentsDataRes = this.segmentsData;
        }
      },
        error: () => {},
        complete: () => {},
      })
    );
  }
  getProductModelData(flag) {
    if (!flag && this.productModelDataRes?.length > 0) {
      if (this.selectedSegment?.length == 0) {
        this.productModelData = this.productModelDataRes;
      }

      return;
    }

    let data = {
      lob: this.selectedSegment,
      search: this.selectedProduct,
      offset: 0,
      limit: 10,
    };
    this.sub.add(
      this.ApiService.getModelList(data).subscribe({
      next: (res: any) => {
        this.productModelData = res.data.models;
        this.productModelDataRes = res.data.models;
      },
        error: () => {},
        complete: () => {},
      })
    );
  }
  selectedSegment: any = '';
  onChangeApplication(item: string, flag: string) {
    this.productModelData = [];
    this.selectedProduct = '';
    if (flag === 'Application') {
      this.selectedApplication = item;
      this.selectedSegment = '';
      this.getSegmentsData(item, true);
    } else if (flag === 'Segment') {
      this.selectedSegment = item;
      this.getProductModelData(true);
    }
  }

  searchFilter(flag, value) {
    if (flag == 'application') {
      this.applicationData = this.applicationDataRes.filter((obj) =>
        obj?.toLowerCase().includes(value?.toLowerCase())
      );
    } else if (flag == 'segment') {
      this.segmentsData = this.segmentsDataRes.filter((obj) =>
        obj.eleName?.toLowerCase().includes(value?.toLowerCase())
      );

      if (value?.length == 0) {
        this.selectedSegment = '';
      }
    } else if (flag == 'product') {
      this.selectedProduct = value;
      this.getProductModelData(true);
    }
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  onApplicationClick() {
    $('.bannerApplication').addClass('bannerApplication');
  }
  selectedProduct: any = '';

  openModal() {
    if (!this.isMobile && this.applicationDataRes?.length == 0) {
      this.getApplicationData();
    }
    const modal = document.getElementById('modalAuto');
    const modalSegment = document.getElementById('modalAutoSegment');
    const modalProduct = document.getElementById('modalAutoProduct');
    if (modal) {
      modal.style.display = 'block';
    }
    if (modalSegment) {
      modalSegment.style.display = 'none';
    }
    if (modalProduct) {
      modalProduct.style.display = 'none';
    }
  }

  closeModal() {
    const modal = document.getElementById('modalAuto');
    if (modal) {
      modal.style.display = 'none';
    }
  }

  openModalSegment() {
    if (!this.isMobile) {
      this.getSegmentsData('', false);
    }
    const modal = document.getElementById('modalAutoSegment');
    const modalApplication = document.getElementById('modalAuto');
    const modalProduct = document.getElementById('modalAutoProduct');
    if (modal) {
      modal.style.display = 'block';
    }
    if (modalApplication) {
      modalApplication.style.display = 'none';
    }
    if (modalProduct) {
      modalProduct.style.display = 'none';
    }
  }

  closeModalSegment() {
    const modal = document.getElementById('modalAutoSegment');
    if (modal) {
      modal.style.display = 'none';
    }
  }

  openModalProduct() {
    if (!this.isMobile) {
      this.getProductModelData(false);
    }
    const modal = document.getElementById('modalAutoProduct');
    const modalApplication = document.getElementById('modalAuto');
    const modalSegment = document.getElementById('modalAutoSegment');
    if (modal) {
      modal.style.display = 'block';
    }
    if (modalApplication) {
      modalApplication.style.display = 'none';
    }
    if (modalSegment) {
      modalSegment.style.display = 'none';
    }
  }

  onSelectProduct(item: string) {
    this.selectedProduct = item;
    this.closeModalProduct();
  }

  closeModalProduct() {
    const modal = document.getElementById('modalAutoProduct');
    if (modal) {
      modal.style.display = 'none';
    }
  }

  search() {
    let vehicle_application = '';
    let actual_lob_name = [];
    let model = [];
    if (this.selectedApplication)
      vehicle_application = this.selectedApplication;
    if (this.selectedSegment) actual_lob_name = [this.selectedSegment];
    if (this.selectedProduct) model = [this.selectedProduct];
    this.router.navigate(['product-list'], {
      queryParams: { vehicle_application, actual_lob_name, model },
    });
  }
}
